import type { FiltersParameters } from '../types';

/**
 * Функция для форматирования параметров запроса на получение данных по фильтрам.
 * Исключает из параметров дополнительные поля, чтобы избежать их отправку в Perxis.
 * @param parameters `FiltersParameters`
 * @returns `FiltersParameters` без qMap
 */
const formatFiltersParameters = (parameters: FiltersParameters): FiltersParameters => {
  const { qMap, ...filter } = parameters.filter || {};
  return {
    ...parameters,
    filter: {
      ...filter,
    },
  };
};

export default formatFiltersParameters;
